import * as React from 'react';

import { IDocument, ILogo } from '../../infrastructure/interfaces';
import CheckBox from '../CheckBox/CheckBox';

export interface ILogoEditorFormProps {
  document: IDocument;
  logos: ILogo[];
  toggleLogo(logo: ILogo): void;
  className: string;
}

export default class LogoEditorForm extends React.Component<ILogoEditorFormProps> {
  render() {
    return (
      <div className="settingsCropsListContainer settingsCropsListContainer--logo">
        {this.props.logos.map((logo) => {
          const document = this.props.document;
          const disabled = document.logos.length >= 2 && document.logos.findIndex(l => l.id === logo.id) === -1;
          const checked = document.logos.findIndex(l => l.id === logo.id) > -1;
          return (<div className="stepRow" key={logo.id}>
            <CheckBox
              onClick={() => this.props.toggleLogo(logo)}
              checked={checked}
              disabled={disabled} />
            <img
              className="logoImage"
              src={logo.image}
              alt={logo.title}
            />
          </div>);
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/LogoEditorForm.tsx